
import "./has_modulor_tip.coffee"
